import "whatwg-fetch";

interface Options {
  headers?: { [key: string]: string };
  body?: string;
}

async function send(
  method: "GET" | "PUT" | "POST",
  url: string,
  options: Options,
  credentials?: "include" | "same-origin" | "omit",
) {
  const headers =
    method === "PUT" || "POST"
      ? { "Content-type": "application/json", ...options.headers }
      : options.headers;
  const body = options && options.body ? options.body : null;

  const response = await window.fetch(url, {
    mode: "cors",
    credentials,
    headers,
    method,
    body,
  });
  if (!response.ok) {
    throw Error(response.statusText);
  }
  // About clone(), see https://stackoverflow.com/questions/40497859/reread-a-response-body-from-javascripts-fetch
  if (response.status === 200 && (await response.clone().text()) === "") {
    return "{}"; // For "200 OK" && "No Content"
  }
  try {
    return await response.json();
  } catch (e) {
    throw Error(e.message);
  }
}

export async function get(
  url: string,
  options?: Options,
  credentials?: "include" | "same-origin" | "omit",
) {
  return await send("GET", url, options || {}, credentials);
}

export async function put(
  url: string,
  options: Options,
  credentials?: "include" | "same-origin" | "omit",
) {
  return await send("PUT", url, options, credentials);
}

export async function post(
  url: string,
  options: Options,
  credentials?: "include" | "same-origin" | "omit",
) {
  return await send("POST", url, options, credentials);
}
